import { Component, Input } from '@angular/core';
import { InsightCategory, InsightData } from 'src/app/shared/model/cybersocxdr/insight';

@Component({
  selector: 'app-insight-carrousel',
  templateUrl: './insight-carrousel.component.html',
})
export class InsightCarrouselComponent {
  @Input() set insights(value: InsightData[]) {
    this._insights = value;
    this.filter();
    this.formatCarrouselInsights();
  }

  //Display title, filter and order
  @Input()
  displayHeader: boolean = true;

  // make InsightCategory enum available in the template
  InsightCategory = InsightCategory;

  _insights: InsightData[];

  filterCategory: InsightCategory | '' = '';
  sortCategory: InsightCategory | '' = '';

  displayInsights: InsightData[] = [];
  carrouselInsights: InsightData[][] = [];

  formatCarrouselInsights() {
    this.carrouselInsights = [];
    for (let i = 0; i < this.displayInsights.length; i++) {
      this.carrouselInsights[Math.floor(i / 2)] = [
        ...(this.carrouselInsights[Math.floor(i / 2)] ?? []),
        this.displayInsights[i],
      ];
    }
  }

  onFilterSelect(value: InsightCategory | '') {
    this.filterCategory = value;
    this.filter();
  }

  onSortSelect(value: InsightCategory | '') {
    this.sortCategory = value;
    this.sort();
  }

  filter() {
    if (this.filterCategory) {
      this.displayInsights = [...this._insights.filter((insight) => insight.category === this.filterCategory)];
    } else {
      this.displayInsights = [...this._insights];
    }
    this.sort();
    this.formatCarrouselInsights();
  }

  sort() {
    if (this.sortCategory)
      this.displayInsights.sort((a, b) => {
        if (a.category === this.sortCategory && b.category === this.sortCategory) return 0;
        if (a.category === this.sortCategory) return -1;
        if (b.category === this.sortCategory) return 1;
        return 0;
      });

    this.formatCarrouselInsights();
  }
}
